import React from 'react';
import SEO from '../components/SEO';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/EditOptionsPage.css'; // Create corresponding styles
import { baseUrl } from '../config';



const EditOptionsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { file } = location.state;

  const handleAiEditClick = () => {
    navigate('/ai-edit', { state: { file } });
  };

  const handleManualEditClick = () => {
    navigate('/vfx', { state: { file } });
  };

  return (
    <div className="edit-options-page">
      <SEO
        title="Edit Options"
        description="Choose editing options for your film production files on ProducerBuddy."
        url="https://producerbuddy.pilomation.com/edit-options"
        robots="noindex, nofollow"
      />
      <h2>Edit Options for: {file.name}</h2>
      <div className="edit-buttons">
        <button onClick={handleAiEditClick} className="edit-button">
          Edit with AI 🤖
        </button>
        <button onClick={handleManualEditClick} className="edit-button">
          Manual Editor ✏️
        </button>
      </div>
    </div>
  );
};

export default EditOptionsPage;

